import React from "react";
import styles from "./full-page.module.scss";

import {
  Avatar,
  Button,
  Col,
  Dropdown,
  Layout,
  Menu,
  MenuProps,
  Space,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import FFLogo2024_Black from "../../assets/images/FFLogo2024_Black.svg";
import logOutOutline from "../../assets/images/log-out-outline.svg";
import { useResponsive } from "../../utils/use-responsive";
import { useAuth } from "../../context/auth.context";
import { User } from "../../types/types";
import LogoutSubMenu from "./menu";

const { Content, Header } = Layout;
type MenuItem = Required<MenuProps>["items"][number];

export const FullPage: React.FC<{
  wide?: boolean;
  children: React.ReactNode;
  user: User;
}> = ( props ) => {
  const { children, user } = props;
  const { isXs } = useResponsive();
  const { signOut } = useAuth();

  const items: MenuItem[] = [
    {
      key: "logout",
      label: (
        <LogoutSubMenu>
          <h3>
            {user.customer.firstname} {user.customer.surname}
          </h3>
          <p>{user.email}</p>
          <Button
            className="logOutUser full-width"
            type="primary"
            data-cy="user-logOut-button"
            onClick={() => {
              signOut.execute();
            }}
          >
            <img src={logOutOutline} /> Log Out
          </Button>
        </LogoutSubMenu>
      ),
    },
  ];

  return (
    <div>
      <Header className={styles["header"]}>
        <div className={styles["logo"]}>
          <img
            src={FFLogo2024_Black}
            alt="Financefair Logo"
            onClick={() => {
              window.location.replace("https://financefair.com");
            }}
          />
        </div>
        <div className={styles["content"]} />
        <div className={styles["actions"]}>
          <Space direction={"horizontal"}>
            <Button
              hidden={true}
              id="logout-button"
              onClick={() => {
                signOut.execute();
              }}
            ></Button>
            <Dropdown
              placement="bottomRight"
              dropdownRender={(menu) => (
                <Menu
                  items={items}
                  style={{ borderRadius: "15px", padding: "10px" }}
                />
              )}
            >
              <Avatar
                style={{ backgroundColor: "#87d068" }}
                icon={<UserOutlined />}
              />
            </Dropdown>
          </Space>
        </div>
      </Header>
      <Content
        className={`${styles["page"]}`}
        style={{ marginTop: isXs ? "" : "64px" }}
      >
        <Col
          xs={{ span: 22 }}
          sm={{ span: 18 }}
          md={{ span: 18 }}
          lg={{ span: 20 }}
          xl={{ span: 20 }}
          xxl={{ span: 20 }}
          style={{ maxWidth: "100%", margin: isXs ? "0" : "0 30px" }}
        >
          <div className={styles["page-content"]}>{children}</div>
        </Col>
      </Content>
    </div>
  );
};
